import { api, apiResolve, useApiGet } from '@sierralabs/core-ui';
function getPath(folderId) {
    return `folders/${folderId === null ? 'root' : folderId}`;
}
export function findFolder(folderId, params = {}) {
    return apiResolve(api.get(getPath(folderId), params));
}
export function useFindFolder(folderId) {
    return useApiGet(getPath(folderId));
}
//# sourceMappingURL=useFindFolder.js.map